import { clearClient } from '../State/client';

export default () => (dispatch) => {

  dispatch(clearClient());
  
}